// @flow

import React, { Component } from "react";
import { ClipLoader } from "react-spinners";
import { getClassName } from "ui-kit/utils/component";

import "./Loader.scss";

const ccn = getClassName("loader");

class Loader extends Component {
  render() {
    return (
      <div className={ccn()}>
        <ClipLoader
          sizeUnit="px"
          size={150}
          color="#21ce99"
          loading={true}
        />
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/ui-kit/components/loader/Loader.js